<template>
  <div class="steps">
    <div v-for="step in stepsArry" :key="step.num" :class="step.class">
      <em>{{step.num}}</em>
      <span>{{step.name}}</span>
      <div class="white-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepsArry: {
      type: Array
    }
  },
  data() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.steps {
  padding: 0 px2rem(15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: px2rem(53);
  > div {
    width: px2rem(150);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    em {
      font-style: normal;
      font-size: px2rem(32);
      display: inline-block;
      width: px2rem(70);
      height: px2rem(70);
      line-height: px2rem(70);
      border-radius: 50%;
      text-align: center;
      border: 1px solid #e9e9e9;
      background: #ccc;
      color: #fff;
    }
    span {
      font-size: px2rem(28);
      display: inline-block;
      margin: px2rem(20) 0;
      color: #80a2df;
    }
    .white-line {
      width: px2rem(180);
      height: 3px;
      position: absolute;
      top: px2rem(35);
      left: px2rem(115);
      background: #ebebeb;
    }
  }
  > div.active {
    em {
      background: #0245bf;
    }
    span {
      color: #0245bf;
      font-weight: 900;
    }
  }
  > div:last-child {
    .white-line {
      display: none;
    }
  }
}
</style>